import Box from "@mui/joy/Box"
import Button from "@mui/joy/Button"
import { useTranslation } from "react-i18next"
import NavigationModal, {
  NavigationModalDynamicItem,
} from "@levana/ui/NavigationModal"
import NavigationModalFooter from "@levana/ui/NavigationModalFooter"

import FaceUncertainIcon from "@common/icons/FaceUncertainIcon"
import ErrorContent from "@future/libs/error/ErrorContent"
import type { AppError } from "@future/libs/error/AppError"

import NotificationSymbol from "./NotificationSymbol"

interface NotificationErrorModalProps {
  message: string
  error: AppError
}

const NotificationErrorModal = (props: NotificationErrorModalProps) => {
  const { t } = useTranslation("common")

  return (
    <NavigationModal rootId={NotificationErrorModal.name}>
      {(modal) => (
        <NavigationModalDynamicItem
          id={NotificationErrorModal.name}
          title={t("notification.error.title")}
          subtitle={props.error.transactionId}
          icon={
            <NotificationSymbol color="danger">
              <FaceUncertainIcon htmlColor="white" fontSize="sm" />
            </NotificationSymbol>
          }
        >
          <Box sx={{ mb: 4 }}>
            <ErrorContent error={props.error} />
          </Box>
          <NavigationModalFooter>
            <Button onClick={modal.close} aria-label="error modal close">
              {t("notification.error.close")}
            </Button>
          </NavigationModalFooter>
        </NavigationModalDynamicItem>
      )}
    </NavigationModal>
  )
}

export default NotificationErrorModal
